import { RequestContext } from '../request-context';
import { HelpPrimaryNav } from './help';
import { Link } from './shared'

export interface ContactUsInput {
    context: RequestContext;
}

export enum ContactUsMainTypes {
    ContactUsRedirect = 'atv.wps#ContactUsRedirect',
    ContactUsWidget = 'atv.wps#ContactUsWidget'
}

export interface ContactUsMain {
    __type: ContactUsMainTypes;
    heading: string;
}

export interface ContactUsRedirect extends ContactUsMain {
    __type: ContactUsMainTypes.ContactUsRedirect
    message: string;
    redirectLink: Link;
}

export interface ContactUsLanguageNotification {
    heading: string;
    message: string;
}

export interface ContactUsWidget extends ContactUsMain {
    __type: ContactUsMainTypes.ContactUsWidget
    languageNotification?: ContactUsLanguageNotification;
    noScriptMessage: string;
    errorMessage: string;
    widgetOptions: any;
}

export interface ContactUsOutput {
    landmark: string;
    primaryNav: HelpPrimaryNav;
    main: ContactUsMain
}
